import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@zhfe/common-library'

@Injectable()
export class LogoffService {
  constructor(
    private http: Http
  ) {
  }

  requestLogoff(closeToken: string) {
    return this.http.post('/account/close/confirm', {
      close_token: closeToken
    })
  }
}
